import * as React from 'react'
import { styles } from './styles.css'
import { LoginLink } from '@/components/subscription/lp/login-link'
import image1 from './images/1.jpg'
import image2 from './images/2.jpg'
import image3 from './images/3.jpg'
import image4 from './images/4.jpg'
import logo from './images/logo.svg'

type Props = {
  isLoggedIn: boolean
}

export const HeroSection: React.FC<Props> = ({ isLoggedIn }) => {
  return (
    <section className={styles.section}>
      <a href="/" className={styles.logo}>
        <img src={logo} alt="FLOWER" />
      </a>
      <LoginLink isLoggedIn={isLoggedIn} className={styles.loginLink} />
      <img className={styles.image} src={image4} style={{ animationDelay: '9s' }} />
      <img className={styles.image} src={image3} style={{ animationDelay: '6s' }} />
      <img className={styles.image} src={image2} style={{ animationDelay: '3s' }} />
      <img className={styles.image} src={image1} style={{ animationDelay: '0s' }} />
      <div className={styles.lines}>
        <h1 className={styles.heading}>
          旬の花がたっぷり届く
          <br />
          FLOWERの定期便
        </h1>
        <p className={styles.text}>2,970円で、今いちばんかわいい花を飾ろう</p>
      </div>
    </section>
  )
}
